import { RouteObject } from 'react-router/dist/lib/context';
import { L3ServiceList } from '../l3-services/components/L3ServiceList/L3ServiceList';

export enum NetworkServicesRoutes {
  L3 = 'l3',
}

export const servicesRoutes: RouteObject[] = [
  {
    path: NetworkServicesRoutes.L3,
    element: <L3ServiceList />,
  },
];
